var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ICellEditorParams } from 'ag-grid-community';
import { DwSelectComponent } from 'ng-quicksilver';
import { FxAgGridValidationEditorComponent } from './fx-ag-grid-validation-editor';
import { FxAgGridEventHandlerService } from './fx-ag-grid-event-handler.service'; // Added by David Lee 25Feb2019
import { of } from 'rxjs'; // Added by David Lee 25Feb2019
var FxAgSelectCellEditorComponent = /** @class */ (function (_super) {
    __extends(FxAgSelectCellEditorComponent, _super);
    function FxAgSelectCellEditorComponent(fb, eventHandler) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.eventHandler = eventHandler;
        return _this;
    }
    // gets called once after the editor is created
    FxAgSelectCellEditorComponent.prototype.agInit = function (params) {
        var _this = this;
        this.params = params; // 把cellEditorParams参数赋给params Added By David Lee 18Feb2019
        this.editType = params.api.gridOptionsWrapper.gridOptions.editType || '';
        this.colId = params.column.colId;
        this.formControl = new FormControl(params.value, params.validators);
        this.validateForm = params.form;
        this.values = Array.isArray(params.values)
            ? of(params.values)
            : params.values;
        this.dwShowSearch = !!params.dwShowSearch;
        this.dwAllowClear = !!params.dwAllowClear;
        if (!params.form) {
            this.validateForm = this.fb.group({});
        }
        this.name = this.params.node.id + '-' + params.column.colId;
        if (this.validateForm.contains(this.name)) {
            this.validateForm.setControl(this.name, this.formControl);
        }
        else {
            this.validateForm.addControl(this.name, this.formControl);
        }
        this.formControl.markAsDirty();
        // 监听赋值 Add David lee 25 Feb 2019
        this.valueSetSubscription = this.eventHandler.valueSet.subscribe(function (event) {
            if ((event.colId === _this.colId) && (event.gridId === params.context.id)) {
                _this.formControl.setValue(event.value);
                _this.message = event.message;
                _this.formControl.markAsDirty();
            }
        });
        _super.prototype.init.call(this);
    };
    // Gets called once after GUI is attached to DOM.
    // Useful if you want to focus or highlight a component
    // (this is not possible when the element is not attached)
    FxAgSelectCellEditorComponent.prototype.afterGuiAttached = function () {
        var _this = this;
        var valueChange = function (value) {
            _this.formControl.setValue(value);
            _this.formControl.markAsDirty({ onlySelf: true });
            if (_this.eventHandler) {
                _this.eventHandler.onBeforeField({
                    gridId: _this.params.context.id,
                    value: _this.formControl.value,
                    rowIndex: _this.params.node.rowIndex,
                    id: _this.params.node.id,
                    colId: _this.colId,
                    controlName: _this.name
                });
            }
            if (_this.eventHandler) {
                _this.eventHandler.onChangeField({
                    gridId: _this.params.context.id,
                    value: _this.formControl.value,
                    rowIndex: _this.params.node.rowIndex,
                    id: _this.params.node.id,
                    colId: _this.colId,
                    controlName: _this.name
                });
            }
        };
        this.cellInput.registerOnChange(valueChange); // Added by David Lee 注册OnChange事件
        var OnTouched = function () {
            if (_this.eventHandler) {
                _this.eventHandler.onAfterField({
                    gridId: _this.params.context.id,
                    value: _this.formControl.value,
                    rowIndex: _this.params.node.rowIndex,
                    id: _this.params.node.id,
                    colId: _this.colId,
                    controlName: _this.name
                });
            }
        };
        this.cellInput.registerOnTouched(OnTouched);
        //    // 通过订阅消息回传onFocus事件
        //   this.cellInput.onChange = (e: any): void => {
        //   if (this.eventHandler) {
        //     this.eventHandler.onChangeField({
        //       value: this.validateForm.controls[this.columnId].value,
        //       rowIndex: this.params.node.rowIndex,
        //       columnId: this.columnId
        //     });
        //   }
        // };
        // // 通过订阅消息回传onClick事件
        // this.cellInput.onClick = (): void => {
        //   if (this.eventHandler) {
        //     this.eventHandler.onBeforeField({
        //       value: this.formControl.value,
        //       rowIndex: this.params.node.rowIndex,
        //       columnId: this.columnId
        //     });
        //   }
        // };
    };
    // If doing full row edit, then gets called when tabbing into the cell.
    FxAgSelectCellEditorComponent.prototype.focusIn = function () {
        this.cellInput.focus();
        if (this.eventHandler) {
            this.eventHandler.onBeforeField({
                gridId: this.params.context.id,
                value: this.formControl.value,
                rowIndex: this.params.node.rowIndex,
                id: this.params.node.id,
                colId: this.colId,
                controlName: this.name
            });
        }
    };
    // If doing full row edit, then gets called when tabbing out of the cell.
    FxAgSelectCellEditorComponent.prototype.focusOut = function () {
        this.cellInput.blur();
        if (this.eventHandler) {
            this.eventHandler.onAfterField({
                gridId: this.params.context.id,
                value: this.formControl.value,
                rowIndex: this.params.node.rowIndex,
                id: this.params.node.id,
                colId: this.colId,
                controlName: this.name
            });
        }
    };
    // Should return the final value to the grid, the result of the editing
    FxAgSelectCellEditorComponent.prototype.getValue = function () {
        return this.formControl.value;
    };
    // Gets called once before editing starts, to give editor a chance to
    // cancel the editing before it even starts.
    FxAgSelectCellEditorComponent.prototype.isCancelBeforeStart = function () {
        return false;
    };
    // Gets called once when editing is finished (eg if enter is pressed).
    // If you return true, then the result of the edit will be ignored.
    FxAgSelectCellEditorComponent.prototype.isCancelAfterEnd = function () {
        return this.validationMessages.length > 0;
        // return false;
    };
    // Gets called once after initialised.
    // If you return true, the editor will appear in a popup
    FxAgSelectCellEditorComponent.prototype.isPopup = function () {
        return false;
    };
    FxAgSelectCellEditorComponent.prototype.ngOnDestroy = function () {
        this.validateForm.removeControl(this.name);
        // 当销毁时取消所有订阅
        if (this.valueSetSubscription) {
            this.valueSetSubscription.unsubscribe();
        }
    };
    return FxAgSelectCellEditorComponent;
}(FxAgGridValidationEditorComponent));
export { FxAgSelectCellEditorComponent };
